/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Google_CalendarInputs */

const cs_enum_google_calendar = /** @type {(inputs: Enum_Google_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Kalendář`)
};

const en_enum_google_calendar = /** @type {(inputs: Enum_Google_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Calendar`)
};

/**
* | output |
* | --- |
* | "Google Calendar" |
*
* @param {Enum_Google_CalendarInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_google_calendar = /** @type {((inputs?: Enum_Google_CalendarInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Google_CalendarInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_google_calendar(inputs)
	return cs_enum_google_calendar(inputs)
});